// extracted by mini-css-extract-plugin
export default {"container":"NC35dUXsyJS4lVHW_rSJ","imageContainer":"n0Zwn1QLncj1rJpvoxsN","image":"iIz62eEiaRGEKOByvRDf","text":"YjYQ0BDrrEKwec3nstmL"};